import { useSyncExternalStore } from "react";
import { useLocation } from "react-router-dom";
import ShareBar from "./ShareBar";
import { canonical } from "@/lib/site";
import { getShareMeta, subscribeShareMeta } from "@/lib/shareMeta";

/**
 * Sitewide share bar that needs no per-page props: it reads the current
 * page's title and description from the share-meta store that <Seo>
 * publishes to on every page render. Hidden on noindex pages (404s) and
 * while the store still holds the previous page's meta during a route
 * transition (the path check).
 */
export default function PageShareBar({
  label = "Share this page",
  className = "",
}: {
  label?: string;
  className?: string;
}) {
  const meta = useSyncExternalStore(subscribeShareMeta, getShareMeta, getShareMeta);
  const location = useLocation();
  if (!meta || meta.noindex) return null;
  if (canonical(meta.path) !== canonical(location.pathname)) return null;
  return (
    <div className={className}>
      <ShareBar title={meta.title} description={meta.description} label={label} />
    </div>
  );
}
